import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ForgotIDPage.css';
import { checkPhoneExists, sendOtp } from '../api/auth';
import UserPageLayout from '../components/UserPageLayout';
import { Box, TextField, Button } from '@mui/material';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { phoneSchema } from '../schemas/phoneSchema';

const ForgotIDPage = () => {
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  //TODO: バリデーション再考
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(phoneSchema),
    defaultValues: {
      phone: '',
    },
  });

  const onSubmit = async (data) => {
    setError('');
    setMessage('');

    const phoneNumber = data.phone;

    try {
      const checkRes = await checkPhoneExists(phoneNumber);

      if (!(checkRes && checkRes.exists === true)) {
        setError('この電話番号は登録されていません');
        return;
      }

      await sendOtp(phoneNumber);

      setMessage('SMSを送信しました。認証コード入力画面へ移動します。');
      localStorage.setItem('resetPhone', phoneNumber);
      setTimeout(() => {
        navigate('/otp-verification-id');
      }, 1500);
    } catch (e) {
      setError('通信エラー');
      console.error(e);
    }
  };

  return (
    <UserPageLayout title="メールアドレス再設定（SMS認証）" maxWidth="sm">
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          boxShadow: 'none',
          minHeight: 'fit-content',
          padding: 0,
          mt: '15dvh',
          alignItems: 'flex-start',
        }}
      >
        <TextField
          type="tel"
          placeholder="電話番号 (例: 09011112222)"
          {...register('phone')}
          autoComplete="tel"
          autoFocus
          fullWidth
          error={errors.phone}
          helperText={errors.phone?.message}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          margin="none"
          sx={{ mt: 3, mb: 2, borderRadius: 5 }}
          disabled={isSubmitting}
        >
          SMS送信
        </Button>

        {error && (
          <Box sx={{ color: 'error.main', mt: 2, textAlign: 'center' }}>
            {error}
          </Box>
        )}
        {message && (
          <Box sx={{ color: 'success.main', mt: 2, textAlign: 'center' }}>
            {message}
          </Box>
        )}
      </Box>
    </UserPageLayout>
  );
};

export default ForgotIDPage;
